import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "tooltip"]

  connect() {
    if (!this.buttonTarget.dataset.action) this.buttonTarget.dataset.action = ""
    this.buttonTarget.dataset.action += " click->copy-to-clipboard#copy"
    // this.buttonTarget.dataset.action += " mouseover->copy-to-clipboard#showTooltip"
    this.buttonTarget.dataset.action += " mouseout->copy-to-clipboard#hideTooltip"

    this.buttonTarget.classList.add("cursor-pointer")
    this.initMessage = this.tooltipTarget.dataset.initMessage
  }

  copy(e) {
    const link = this.element.dataset.redirectUrl

    // Spróbuj użyć nowoczesnego API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(link).then(() => {
        this.showCopiedMessage(e)
      }).catch((err) => {
        console.error("Failed to copy using clipboard API:", err)
        this.fallbackCopy(link, e)
      })
    } else {
      // Fallback dla starszych przeglądarek lub HTTP
      console.log("fallbackCopy:", link)
      this.fallbackCopy(link, e)
    }
  }

  fallbackCopy(text, e) {
    // Użyj starszej metody z textarea
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      const successful = document.execCommand("copy")
      if (successful) {
        this.showCopiedMessage(e)
      } else {
        console.error("Failed to copy using execCommand")
      }
    } catch (err) {
      console.error("Failed to copy:", err)
    } finally {
      document.body.removeChild(textarea)
    }
  }

  showCopiedMessage(e) {
    this.showTooltip(e)
    this.tooltipTarget.innerText = this.tooltipTarget.dataset.copiedMessage
    setTimeout(() => {
      this.hideTooltip(e)
      this.tooltipTarget.innerText = this.initMessage
    }, 1500)
  }

  showTooltip(_e) {
    this.tooltipTarget.classList.remove("hidden")
  }

  hideTooltip(_e) {
    this.tooltipTarget.classList.add("hidden")
  }
}
